export const API_V1_PREFIX = "/api/v1"

export const PATH_PROJECTS = `${API_V1_PREFIX}/projects`
export const SUB_PATH_PROJECT_CLIENTS = "/clients"

export const PATH_WATSONS = `${API_V1_PREFIX}/watsons`

export const PATH_RASAS = `${API_V1_PREFIX}/rasas`

export const PATH_ORCHESTRATORS = `${API_V1_PREFIX}/orchestrators`

export const PATH_CLIENTS = `${API_V1_PREFIX}/clients`
export const SUB_PATH_CLIENT_FEATURES = `/features`

export const SUB_PATH_CLIENT_WATSON = `/watson`
export const SUB_PATH_CLIENT_RASA = `/rasa`
export const SUB_PATH_CLIENT_ORCHESTRATOR = `/orchestrator`

export const SUB_PATH_CLIENT_FRONTEND_CONFIG = `/frontendConfig`
export const PATH_UNNECESSARY_PHRASES = `${API_V1_PREFIX}/unnecessaryPhrases`

export const PATH_TEXT_TO_SPEECH_TRANSFORM = `${API_V1_PREFIX}/textToSpeechTransform`
export const SUB_PATH_CLIENT_TEXT_TO_SPEECH_TRANSFORM = "/textToSpeechTransform"

export const PATH_LLM_PROVIDERS = `${API_V1_PREFIX}/llm-providers`
export const PATH_LLM_MODELS = `${API_V1_PREFIX}/llm-models`

export const PATH_MASKING_CONFIGS = `${API_V1_PREFIX}/masking-configs`
export const PATH_SKILLS = `${API_V1_PREFIX}/skills`




export const PATH_FEATURES = `${API_V1_PREFIX}/features`
export const SUB_PATH_PROJECT_LLM_MODELS = "/llm-models"
export const SUB_PATH_PROJECT_LLM_MODELS_ORDER = `${SUB_PATH_PROJECT_LLM_MODELS}/order`
